(() => {
  const INTERVAL_MS = 3500;

  function initAutoplay() {
    const carousel =
      document.querySelector('.cc-icons-with-text carousel-slider') ||
      document.querySelector('.icons-with-text carousel-slider');
    if (!carousel) return;

    const slider = carousel.querySelector('.slider');
    if (!slider) return;

    const items = [...carousel.querySelectorAll('.slider__item')];
    if (items.length < 2) return;

    let index = 0;

    setInterval(() => {
      index = (index + 1) % items.length;
      const itemRect = items[index].getBoundingClientRect();
      const sliderRect = slider.getBoundingClientRect();
      const targetLeft = slider.scrollLeft + (itemRect.left - sliderRect.left);
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }, INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initAutoplay, 1500));
  } else {
    setTimeout(initAutoplay, 1500);
  }
})();
